module.exports = {"360103001":"南浦街道","360103002":"朝阳洲街道","360103004":"广润门街道","360103005":"西湖街道","360103006":"系马桩街道","360103007":"绳金塔街道","360103009":"丁公路街道","360103010":"南站街道","360103011":"桃源街道","360103012":"十字街街道","360103013":"朝农街道","360103101":"桃花镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360103.json
// module id = 1359
// module chunks = 0